import { Converter } from '../types/converter';

export const accelerationConverter: Converter = {
  id: 'acceleration',
  name: 'Acceleration Converter',
  icon: 'ArrowUpRight',
  categories: ['engineering', 'physics'],
  units: [
    // Base SI unit
    { name: 'Meter/square second', symbol: 'm/s²', factor: 1 },
    
    // SI derived units
    { name: 'Decimeter/square second', symbol: 'dm/s²', factor: 0.1 },
    { name: 'Kilometer/square second', symbol: 'km/s²', factor: 1000 },
    { name: 'Hectometer/square second', symbol: 'hm/s²', factor: 100 },
    { name: 'Dekameter/square second', symbol: 'dam/s²', factor: 10 },
    { name: 'Centimeter/square second', symbol: 'cm/s²', factor: 0.01 },
    { name: 'Millimeter/square second', symbol: 'mm/s²', factor: 0.001 },
    { name: 'Micrometer/square second', symbol: 'µm/s²', factor: 1e-6 },
    { name: 'Nanometer/square second', symbol: 'nm/s²', factor: 1e-9 },
    { name: 'Picometer/square second', symbol: 'pm/s²', factor: 1e-12 },
    { name: 'Femtometer/square second', symbol: 'fm/s²', factor: 1e-15 },
    { name: 'Attometer/square second', symbol: 'am/s²', factor: 1e-18 },
    
    // CGS unit
    { name: 'Gal/Galileo', symbol: 'Gal', factor: 0.01 },  // Combined into one unit to avoid duplicate key
    
    // Imperial/US units
    { name: 'Mile/square second', symbol: 'mi/s²', factor: 1609.344 },
    { name: 'Yard/square second', symbol: 'yd/s²', factor: 0.9144 },
    { name: 'Foot/square second', symbol: 'ft/s²', factor: 0.3048 },
    { name: 'Inch/square second', symbol: 'in/s²', factor: 0.0254 },
    
    // Standard gravity
    { name: 'Acceleration of gravity', symbol: 'g', factor: 9.80665 }
  ]
};
